import { Box, BoxProps } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import VidletLogo from "components/VidletLogo";
import { ReactNode, useState } from "react";

interface Props extends Omit<BoxProps, "component" | "sx"> {
  logoUrl?: string | undefined | null;
  sx?: SystemStyleObject;
  fallback?: ReactNode;
}

export default function WhiteLabelLogo({
  logoUrl,
  sx,
  maxHeight = 36,
  maxWidth = 100,
  fallback = <VidletLogo />,
  ...boxProps
}: Props) {
  const [broken, setBroken] = useState(false);

  if (!logoUrl || broken) {
    return fallback;
  }

  return (
    <Box
      {...boxProps}
      component="img"
      src={logoUrl}
      alt="Account logo"
      onError={() => setBroken(true)}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      sx={{ objectFit: "contain", ...sx }}
    />
  );
}
